import axios from '../../service/index'
import {baseUrl} from '../config'

export default {
    queryValveZoneDataInfo: (params) => {
        return axios.post(`${baseUrl}/memberportal/zh/api/zone/valvezone/queryValveZoneDataInfo.do`, params)
    },
    saveValveZoneDataInfo: (params) => {
        return axios.post(`${baseUrl}/memberportal/zh/api/zone/valvezone/saveValveZoneDataInfo.do`, params)
    },
    exportValveZoneDataInfo: (params) => {
        return axios.post(`${baseUrl}/memberportal/zh/api/zone/valvezone/exportValveZoneDataInfo.do`, params)
    },
    getValveZoneDownloadData: (query) => {
        return `${baseUrl}/memberportal/zh/api/zone/valvezone/getValveZoneDownloadData.do?fileUrl=${query}`
    }
}
